import axios from 'app/helpers/MyAxios';

const service = {
  fetchOne: type => axios.get(axios.addApiUrl(`task/active-task?type_code=${type}`)),
  create: values => axios.post(axios.addApiUrl(`task/takes`), values),
};

export default service;
